import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CloseIcon } from "../../util/Icons";

const northRunQuotes = [
  "I'm a Winter Warrior",
  "I'm Stronger Than Winter",
  "Turning Cold Days Into Milestones",
  "Winter Warriors Don't Quit",
  "Snow Won't Stop Me",
  "This Winter, I'm Unstoppable",
];

const config = {
  default: {
    beginner: { flavorText: "", color: "", overlayURL: "", imageName: "", quotes: ["default"] },
    finisher: { flavorText: "", color: "", overlayURL: "", imageName: "", quotes: ["finisher"] },
  },
  "ccc-c": {
    beginner: {
      flavorText: "Create your Celebrate Canada Participant Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/beginner-image-ccc.png",
      imageName: "Celebrate-Canada-Challenge-2026-C.jpg",
    },
    finisher: {
      flavorText: "Create your Celebrate Canada Finisher Picture!",
      color: "rgba(254, 79, 79, 1)",
      overlayURL: "/img/pictureOverlays/CCC-finisher-2026-C.png",
      imageName: "Celebrate-Canada-Challenge-2026-C-Finisher.jpg",
    },
  },
  "ccc-a1": {
    beginner: {
      flavorText: "Create your Celebrate Canada Participant Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/beginner-image-ccc.png",
      imageName: "Celebrate-Canada-Challenge-2026-First-A.jpg",
    },
    finisher: {
      flavorText: "Create your Celebrate Canada Finisher Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/CCC-finisher-2026-A1.png",
      imageName: "Celebrate-Canada-Challenge-2026-First-A-Finisher.jpg",
    },
  },
  "ccc-n": {
    beginner: {
      flavorText: "Create your Celebrate Canada Participant Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/beginner-image-ccc.png",
      imageName: "Celebrate-Canada-Challenge-2026-N.jpg",
    },
    finisher: {
      flavorText: "Create your Celebrate Canada Finisher Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/CCC-finisher-2026-N.png",
      imageName: "Celebrate-Canada-Challenge-2026-N-Finisher.jpg",
    },
  },
  "ccc-a2": {
    beginner: {
      flavorText: "Create your Celebrate Canada Participant Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/beginner-image-ccc.png",
      imageName: "Celebrate-Canada-Challenge-2026-Second-A.jpg",
    },
    finisher: {
      flavorText: "Create your Celebrate Canada Finisher Picture!",
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/CCC-finisher-2026-A2.png",
      imageName: "Celebrate-Canada-Challenge-2026-Second-A-Finisher.jpg",
    },
  },
  "60northrun2027": {
    finisherBadgeURL: "/img/60NR-2027-finisher-badge.png",
    beginner: {
      flavorText: "Create your 60° North Run 2027 Participant Picture!",
      color: "#00aeef",
      overlayURL: "/img/pictureOverlays/60NR-2027-beginner-image.png",
      imageName: "60-North-Run-2027-Participant.jpg",
      quotes: northRunQuotes,
      quotePosition: { containerLeft: 440, containerRight: 1040, yOffset: 53, fontSize: 44 },
    },
    finisher: {
      flavorText: "Create your 60° North Run 2027 Finisher Picture!",
      color: "#00aeef",
      overlayURL: "/img/pictureOverlays/60NR-2027-finisher-image.png",
      imageName: "60-North-Run-2027-Finisher.jpg",
    },
  },
  north: {
    beginner: {
      flavorText: "Create your Winter Warrior Picture!",
      color: "#4FACFE",
      overlayURL: "/img/pictureOverlays/60nr-pre-26.png",
      imageName: "60-North-run-2026.jpg",
      quotes: northRunQuotes,
      quotePosition: { containerLeft: 240, containerRight: 1030, yOffset: 38, fontSize: 58 },
    },
    finisher: {
      flavorText: "Create your Winter Warrior Finisher Picture!",
      color: "#4FACFE",
      overlayURL: "/img/pictureOverlays/60nr-finisher-26.png",
      imageName: "60-North-run-2026-Finisher.jpg",
    },
  },
  fall2026: {
    beginner: {
      flavorText: "Create your Joy of Fall Run 2026 Participant Picture!",
      color: "#ff5a00",
      overlayURL: "/img/pictureOverlays/JOF-2026-Beginner.png",
      imageName: "Joy-of-Fall-Run-2026-Beginner.jpg",
      quotes: [
        "Falling For Every Step",
        "Cool Air, Warm Spirit",
        "Crunching Leaves, Chasing Goals",
        "My Pace, My Fall Adventure",
        "Golden Leaves, Fresh Goals",
        "Finding Joy In Every Kilometre",
      ],
      quotePosition: { containerLeft: 340, containerRight: 1040, yOffset: 58, fontSize: 44 },
      quoteColor: "#17130d",
    },
    finisher: {
      flavorText: "Create your Joy of Fall Run 2026 Finisher Picture!",
      color: "#ff5a00",
      overlayURL: "/img/pictureOverlays/JOF-2026-Finisher.png",
      imageName: "Joy-of-Fall-Run-2026-Finisher.jpg",
    },
  },
  joy: {
    beginner: {
      flavorText: "Create your Joy of Fall Participant Picture!",
      color: "#ff5a00",
      overlayURL: "/img/pictureOverlays/JOF-pre-25.png",
      imageName: "Joy-of-fall-2025.jpg",
    },
    finisher: {
      flavorText: "Create your Joy of Fall Finisher Picture!",
      color: "#ff5a00",
      overlayURL: "/img/pictureOverlays/JOF-finisher-25.png",
      imageName: "Joy-of-fall-2025.jpg",
    },
  },
  big: {
    beginner: {
      flavorText: "Create your Big Canada Run Participant Image!",
      teams: true,
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/TBCR-2026-leg1-beginner.png",
      overlayList: {
        [8000]: "/img/pictureOverlays/TBCR-2026-leg1-beginner.png",
        [10000]: "/img/pictureOverlays/TBCR-2026-leg2-beginner.png",
        [18000]: "/img/pictureOverlays/TBCR-2026-leg3-beginner.png",
      },
      teamTextPosition: { x: 300, y: 1010, maxWidth: 734 },
      imageName: "TBCR-2026.jpg",
    },
    finisher: {
      flavorText: "Create your Big Canada Run Finisher Image!",
      teams: true,
      color: "#fe4f4f",
      overlayURL: "/img/pictureOverlays/TBCR-2026-leg1-finisher.png",
      overlayList: {
        [8000]: "/img/pictureOverlays/TBCR-2026-leg1-finisher.png",
        [10000]: "/img/pictureOverlays/TBCR-2026-leg2-finisher.png",
        [18000]: "/img/pictureOverlays/TBCR-2026-leg3-finisher.png",
      },
      teamTextPosition: { x: 300, y: 1010, maxWidth: 734 },
      imageName: "TBCR-2026-Finisher.jpg",
    },
  },
  winter: {
    beginner: {
      flavorText: "Create your Winter Warrior Picture!",
      color: "#4FACFE",
      overlayURL: "/img/pictureOverlays/ISFWC-pre-26.png",
      imageName: "ISFWC-2026.jpg",
      quotes: [
        "I'm Still a Winter Warrior",
        "I Eat -40°C For Breakfast",
        "I'm Beating Winter",
        "January Was Just My Warm-Up",
        "Making Winter My Playground",
        "Momentum > Motivation",
      ],
      quotePosition: { containerLeft: 140, containerRight: 930, yOffset: 85, fontSize: 58 },
    },
    finisher: {
      flavorText: "Create your Winter Warrior Finisher Picture!",
      color: "#4FACFE",
      overlayURL: "/img/pictureOverlays/ISFWC-finisher-26.png",
      imageName: "ISFWC-2026-Finisher.jpg",
    },
  },
  bloom: {
    beginner: {
      flavorText: "Create your Canada Blooms Picture!",
      color: "#188f44",
      overlayURL: "/img/pictureOverlays/April-2026-Beginner-Image.png",
      imageName: "April-2026-Beginner-Image.jpg",
      quotes: [
        "In My Flourishing Era",
        "Pale Legs Approaching",
        "Nothing Holds Me Back",
        "I'm Unstoppable",
        "Flourishing With Every Mile",
        "Ready To Run, Ready To Bloom",
      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 35, fontSize: 58 },
    },
    finisher: {
      flavorText: "Create your Canada Blooms Run Finisher Picture!",
      color: "#188f44",
      overlayURL: "/img/pictureOverlays/April-2026-finisher-Image.png",
      imageName: "April-2026-finisher-Image.jpg",
    },
  },
  slush: {
    beginner: {
      flavorText: "Create your Slush & Sweat Picture!",
      color: "#ce17f3ff",
      overlayURL: "/img/pictureOverlays/March-2026-Beginner-Image.png",
      imageName: "March-2026-Beginner-Image.jpg",
      quotes: [
        "Slush & Sweat is my jam",
        "Will Run For Dry Socks",
        "I'm melting the snow",
        "Outlasting The Snowman",
        "Powered By Slush & Grit",
        "Momentum > Motivation",
      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 85, fontSize: 58 },
    },
    finisher: {
      flavorText: "Create your Slush & Sweat Finisher Picture!",
      color: "#ce17f3ff",
      overlayURL: "/img/pictureOverlays/March-2026-Finisher-Image.png",
      imageName: "March-2026-Finisher-Image.jpg",
    },
  },
  spark2026: {
    beginner: {
      flavorText: "Create your Spark Challenge Participant Picture!",
      color: "#f97316",
      overlayURL: "/img/pictureOverlays/Spark-2026-Beginner-Image.png",
      imageName: "Spark-2026-Beginner-Image.jpg",
      quotes: [
        "Friendship challenge accepted!",
        "More steps. More stories.",
        "Running for more than just the miles.",
        "Still building momentum.",
        "Together, we're brighter.",
        "This is what showing up looks like.",
      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 85, fontSize: 49 },

    },
    finisher: {
      flavorText: "Create your Spark Challenge Finisher Picture!",
      color: "#f97316",
      overlayURL: "/img/pictureOverlays/Spark-2026-Finisher-Image.png",
      imageName: "Spark-2026-Finisher-Image.jpg",
    },
  },
  rhythm2026: {
    beginner: {
      flavorText: "Create your Find Your Rhythm Challenge Participant Picture!",
      color: "#b8862d",
      overlayURL: "/img/pictureOverlays/Rhythm-Beginner-Image.png",
      imageName: "Rhythm-2026-Beginner-Image.jpg",
      quotes: [
        "Moving To My Own Beat",
        "Finding My Rhythm",
        "Every Mile Has A Rhythm",
        "In Tune With My Goals",
        "Strong Steps, Steady Beat",
        "Turning Miles Into Music",
      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 58, fontSize: 48 },
    },
    finisher: {
      flavorText: "Create your Find Your Rhythm Challenge Finisher Picture!",
      color: "#b8862d",
      overlayURL: "/img/pictureOverlays/Rhythm-Finisher-Image.png",
      imageName: "Rhythm-2026-Finisher-Image.jpg",
    },
  },
  november2026: {
    beginner: {
      flavorText: "Create your Milestones & Masterpieces Challenge Participant Picture!",
      color: "#b8862d",
      overlayURL: "/img/pictureOverlays/November-Beginner-Image.png",
      imageName: "November-2026-Beginner-Image.jpg",
      quotes: [
        "Walking Into My Masterpiece",
        "Every Step A Brushstroke",
        "November Is My Canvas",
        "Making Moves, Making Art",
        "Cool Days, Colourful Goals",
        "Small Steps, Bold Strokes",
      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 95, fontSize: 52 },
    },
    finisher: {
      flavorText: "Create your Milestones & Masterpieces Challenge Finisher Picture!",
      color: "#b8862d",
      overlayURL: "/img/pictureOverlays/November-Finisher-Image.png",
      imageName: "November-2026-Finisher-Image.jpg",
    },
  },
  lakes: {
    beginner: {
      flavorText: "Create your Lakes Challenge Participant Picture!",
      color: "#00696B",
      overlayURL: "/img/pictureOverlays/Lakes-Beginner-Image.png",
      imageName: "Lakes-Beginner-Image.jpg",
      quotes: [
        "Powered By Fresh Air",
        "Making Waves With Every Mile",
        "Lake Days, Stronger Ways",
        "Flowing Toward The Finish",
        "Calm Water, Steady Steps",
        "Miles Deep, Spirit High",

      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 85, fontSize: 52 },
      quoteColor: "#000",
    },
    finisher: {
      flavorText: "Create your Lakes Challenge Finisher Picture!",
      color: "#00696B",
      overlayURL: "/img/pictureOverlays/Lakes-Finisher-Image.png",
      imageName: "Lakes-Finisher-Image.jpg",
    },
  },
  nature2026: {
    beginner: {
      flavorText: "Create your Nature Calls Challenge Participant Picture!",
      color: "#0b523b",
      overlayURL: "/img/pictureOverlays/Nature-Beginner-Image.png",
      imageName: "Nature-Beginner-Image.jpg",
      quotes: [
        "Outside Is My Happy Place",
        "Wild At Heart",
        "Call Of The Wild",
        "Fresh Air, Strong Legs",
        "Roaming Toward My Goal",
        "Powered By The Great Outdoors",
      ],
      quotePosition: { containerLeft: 360, containerRight: 980, yOffset: 58, fontSize: 44 },
      quoteColor: "#0b523b",
    },
    finisher: {
      flavorText: "Create your Nature Calls Challenge Finisher Picture!",
      color: "#0b523b",
      overlayURL: "/img/pictureOverlays/Nature-Finisher-Image.png",
      imageName: "Nature-Finisher-Image.jpg",
    },
  },
  chasing2026: {
    beginner: {
      flavorText: "Create your Chasing Feathers Challenge ParticipantPicture!",
      color: "#3b82f6",
      overlayURL: "/img/pictureOverlays/Chasing-Beginner-Image.png",
      imageName: "April-2026-Beginner-Image.jpg",
      quotes: [
        "Born to Fly",
        "Soaring Toward My Goals",
        "Sky’s Not The Limit",
        "Healthy Body, Soaring Soul",
        "Rising Strong Every Day",
        "Built To Move, Ready To Rise",
      ],
      quotePosition: { containerLeft: 400, containerRight: 930, yOffset: 45, fontSize: 58 },
    },
    finisher: {
      flavorText: "Create your Chasing Feathers Challenge Finisher Picture!",
      color: "#3b82f6",
      overlayURL: "/img/pictureOverlays/Chasing-Finisher-Image.png",
      imageName: "April-2026-Finisher-Image.jpg",
    },
  },
};

const raceNameFallbackKeys = ["north", "joy", "big", "winter", "bloom", "slush", "chasing"];

function getConfigByKey(key = "default", finisher = false) {
  const imageConfig = config[key] || config.default;
  if (finisher) return imageConfig.finisher;
  return imageConfig.beginner;
}

function getConfigByRaceName(name = "", finisher = false) {
  if (!name) return getConfigByKey("default", finisher);
  if (typeof name !== "string") return getConfigByKey("default", finisher);

  const normalizedName = name.toLowerCase();
  for (const key of raceNameFallbackKeys) {
    if (normalizedName.includes(key)) {
      return getConfigByKey(key, finisher);
    }
  }

  return getConfigByKey("default", finisher);
}

function getConfig({ imagePreset = "", name = "", finisher = false } = {}) {
  if (imagePreset && config[imagePreset]) {
    return getConfigByKey(imagePreset, finisher);
  }

  return getConfigByRaceName(name, finisher);
}

export function getPresetFinisherBadge(imagePreset = "") {
  return config[imagePreset]?.finisherBadgeURL || "";
}

// True when the race has its own picture frame (not just the plain default).
export function hasRacePicture({ imagePreset = "", raceName = "", finisher = false } = {}) {
  return Boolean(getConfig({ imagePreset, name: raceName, finisher })?.overlayURL);
}

export default function CreateImage({ raceName, imagePreset = "", finisher = false, distance = 0, onDone }) {
  const settings = getConfig({ imagePreset, name: raceName, finisher });
  const [zoomLevel, setZoomLevel] = useState(100);
  const [selectedQuote, setSelectedQuote] = useState(settings?.quotes?.[0] || null);
  const [teamName, setTeamName] = useState("");
  const [teamTextSize, setTeamTextSize] = useState(60);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [enabledOffsetControls, setEnabledOffsetControls] = useState(false);
  const canvasRef = useRef(null);
  const overlayRef = useRef(null);
  const uploadedPictureRef = useRef(null);
  const zoomInputRef = useRef(null);
  const navigate = useNavigate();

  const toggleOffsetControls = () => setEnabledOffsetControls((prev) => !prev);

  useEffect(() => {
    if (overlayRef.current) return;
    const img = new Image();
    if (settings?.overlayList && settings?.overlayList[distance]) {
      img.src = settings.overlayList[distance];
    } else {
      img.src = settings.overlayURL;
    }
    img.onload = () => {
      overlayRef.current = img;
      drawCanvas();
    };
    img.onerror = () => {
      overlayRef.current = null;
    };
  }, [settings]);

  useEffect(() => {
    drawCanvas();
  }, [zoomLevel, selectedQuote, offsetY, offsetX, teamName, teamTextSize]);

  function drawCanvas() {
    if (!canvasRef.current) return;
    let zoom = zoomLevel / 100;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const uploadedPicture = uploadedPictureRef.current;
    canvas.width = 1080;
    canvas.height = 1080;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (uploadedPicture) {
      let xpos = (-uploadedPicture.width * zoom) / 2 + canvas.width / 2 + (offsetX / 100) * canvas.width;
      let ypos = (-uploadedPicture.height * zoom) / 2 + canvas.height / 2 + (offsetY / 100) * canvas.height;
      ctx.drawImage(uploadedPicture, xpos, ypos, uploadedPicture.width * zoom, uploadedPicture.height * zoom);
    }

    // Draw overlay border image
    if (overlayRef.current) {
      ctx.drawImage(overlayRef.current, 0, 0, canvas.width, canvas.height);
    }

    // Quote positioning - uses quotePosition config if available
    if (settings.quotes && settings.quotePosition) {
      const { containerLeft, containerRight, yOffset, fontSize } = settings.quotePosition;
      const containerCenter = (containerLeft + containerRight) / 2;
      ctx.font = `bold ${fontSize}px Impact`;
      ctx.fillStyle = settings.quoteColor || "#fff";
      ctx.textAlign = "center";
      ctx.fillText(selectedQuote, containerCenter, canvas.height - yOffset);
    }

    const teamTextPosition = settings.teamTextPosition || {};
    const textX = teamTextPosition.x ?? canvas.width * 0.06;
    const textY = teamTextPosition.y ?? canvas.height * 0.935;
    const maxW = teamTextPosition.maxWidth ?? canvas.width * 0.68;
    if (teamName.length > 0) {
      ctx.textAlign = "left";
      ctx.fillStyle = "white";
      ctx.strokeStyle = "black";
      ctx.font = `bold ${teamTextSize}px Merriweather, serif`;
      ctx.fillText(teamName, textX, textY, maxW);
    }
  }

  function ImageInput(e) {
    const picture = e?.target?.files;
    if (!picture) return;
    if (picture?.length != 1) return;

    let img = new Image();
    img.src = URL.createObjectURL(picture[0]);
    uploadedPictureRef.current = img;
    img.onload = () => {
      let zoom = canvasRef.current.width / img.width;
      if (zoomInputRef.current) zoomInputRef.current.value = zoom * 100;
      setZoomLevel(zoom * 100);
      setOffsetX(0);
      setOffsetY(0);
      drawCanvas();
    };
  }

  function DownloadPicture(e) {
    if (!uploadedPictureRef.current) return; // No download an empty frame
    // Prevent default click behavior
    e.preventDefault();

    // Draw the canvas content to ensure it's updated
    drawCanvas();
    onDone?.("download");

    // Convert the canvas to a Blob and initiate download
    canvasRef.current.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = settings.imageName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, "image/jpeg");
  }
  function PostPicture(e) {
    if (!uploadedPictureRef.current) return;
    e.preventDefault();
    drawCanvas();
    onDone?.("post");

    canvasRef.current.toBlob((blob) => {
      const file = new File([blob], settings.imageName, { type: blob.type });
      navigate("/", { state: { createdImage: file } });
    }, "image/jpeg");
  }
  return (
    <div className="fixed inset-0 bg-slate-600 bg-opacity-50 backdrop-blur-sm overflow-y-auto" data-close>
      <div className="max-w-xl h-fit mx-auto bg-white rounded-lg relative pt-2 px-5 pb-5 anim-card">
        <button className="right-2 top-2 absolute rounded-full bg-gray-200 p-1" data-close>
          <CloseIcon size={24} className="pointer-events-none" />
        </button>
        <div className="flex flex-col mt-4 text-center gap-2">
          <h5 className="mt-2">{settings.flavorText}</h5>

          {/* Image file input */}
          <label htmlFor="imageInput" className="rounded-md p-2 text-white cursor-pointer" style={{ backgroundColor: settings.color }}>
            Upload Image
            <input type="file" name="imageInput" id="imageInput" className="hidden" accept="image/*" onInput={ImageInput} />
          </label>

          {/* Label input */}
          {settings.quotes && (
            <div>
              <p className="m-0">Select a Quote</p>
              <select
                name=""
                id=""
                className="p-2 border border-slate-300 rounded-md outline-none"
                defaultValue={settings?.quotes[0]}
                onInput={(e) => {
                  setSelectedQuote(e.target.value);
                }}
              >
                {settings.quotes &&
                  settings.quotes.map((q) => {
                    return (
                      <option key={q} value={q}>
                        {q}
                      </option>
                    );
                  })}
              </select>
            </div>
          )}

          {/* Zoom input */}
          <label htmlFor="zoom" className="flex flex-col gap-2">
            <div className="flex justify-center gap-3 items-center">
              <button
                className="px-2 text-2xl font-bold cursor-pointer border rounded-xl flex items-center"
                onClick={() => {
                  setZoomLevel((prev) => prev - 1);
                }}
              >
                -
              </button>
              <p className="m-0 select-none">zoom {zoomLevel.toFixed(0)}%</p>
              <button
                className="px-2 text-2xl font-bold cursor-pointer border rounded-xl"
                onClick={() => {
                  setZoomLevel((prev) => prev + 1);
                }}
              >
                +
              </button>
            </div>
            <input
              type="range"
              ref={zoomInputRef}
              min={10}
              max={300}
              defaultValue={100}
              step={1}
              onInput={(e) => {
                setZoomLevel(parseInt(e.target.value));
              }}
              style={{ accentColor: settings.color }}
            />
          </label>

          {/* Team name input */}
          {settings.teams && (
            <div className="flex flex-col text-left">
              <label htmlFor="teamName" className="m-0">
                Team Name
              </label>
              <input
                type="text"
                id="teamName"
                className="border rounded-lg p-1"
                value={teamName}
                onChange={(e) => {
                  setTeamName(e.target.value);
                }}
              />
              <label htmlFor="teamNameSize" className="m-0 mt-2">
                Text Size: {teamTextSize}px
              </label>
              <input
                type="range"
                id="teamNameSize"
                min={20}
                max={150}
                step={1}
                value={teamTextSize}
                className="border rounded-lg"
                style={{ accentColor: settings.color }}
                onChange={(e) => {
                  setTeamTextSize(e.target.valueAsNumber);
                }}
              />
            </div>
          )}

          {/* Position check box */}
          <label htmlFor="offsetControls" className="select-none cursor-pointer flex gap-1 justify-center">
            Change Position
            <input type="checkbox" name="" id="offsetControls" checked={enabledOffsetControls} onChange={() => toggleOffsetControls()} />
          </label>
          <div className={`grid ${enabledOffsetControls ? "grid-cols-[20px,1fr]" : " "}`}>
            {enabledOffsetControls && (
              <input
                type="range"
                name="posYControl"
                id=""
                min={0}
                max={100}
                value={-offsetY + 50}
                style={{ writingMode: "vertical-lr", direction: "rtl", accentColor: settings.color }}
                onChange={(e) => {
                  let max = e.target?.max || 100;
                  let val = e.target?.valueAsNumber;
                  setOffsetY(parseInt(max) / 2 - val);
                }}
              />
            )}
            <canvas ref={canvasRef} className="aspect-square w-full h-auto border"></canvas>
            {enabledOffsetControls && (
              <input
                type="range"
                name="posXControl"
                id=""
                min={0}
                max={100}
                value={offsetX + 50}
                className="col-start-2"
                style={{ accentColor: settings.color }}
                onInput={(e) => {
                  let max = e.target?.max || 100;
                  let val = e.target?.valueAsNumber;
                  setOffsetX(val - parseInt(max) / 2);
                }}
              />
            )}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <button type="button" className="border rounded-lg p-2" onClick={DownloadPicture}>
              Download
            </button>
            <button
              type="button"
              className="border rounded-lg p-2 text-white"
              style={{ backgroundColor: settings.color, borderColor: settings.color }}
              onClick={PostPicture}
            >
              Post
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
